import { render, staticRenderFns } from "./button-red.vue?vue&type=template&id=d0f0a048&"
import script from "./button-red.vue?vue&type=script&lang=ts&"
export * from "./button-red.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports